import React from 'react';

import {AttendanceStatus} from '../schema';
import IconRegistered from '../components/icon/IconRegistered';
import IconCancelled from '../components/icon/IconCancelled';
import IconStudent from '../components/icon/IconStudent';
import ExtendedDropdownMenuItem from './ExtendedDropdownMenuItem';

type Props = {
  status: AttendanceStatus
  confirmedEvent?: boolean
  futureEvent?: boolean
  onChange?: (value: string) => void
}

export default function AttendeeStatusSwitch({
                                               status, confirmedEvent, futureEvent, onChange
                                             }: Props) {

  const statusList = [
    {'status': AttendanceStatus.REGISTERED, 'caption': 'Registered', 'icon': IconRegistered},
    {'status': AttendanceStatus.PARTICIPATED, 'caption': 'Participated', 'icon': IconStudent},
    {'status': AttendanceStatus.CANCELLED, 'caption': 'Cancelled', 'icon': IconCancelled}
  ]
  const canParticipate = confirmedEvent && !futureEvent
  const participatedTooltip = confirmedEvent && futureEvent ?
    'The status becomes available when the event starts' :
    'Confirm the event to activate this status';

  return (
    <>
      {statusList.map((item) => {
        const isSelected = item.status === status;
        const disabled = !isSelected && !canParticipate && item.status === AttendanceStatus.PARTICIPATED
        return (
          <ExtendedDropdownMenuItem
            key={item.status}
            caption={item.caption}
            icon={item.icon}
            tooltip={participatedTooltip}
            onClick={onChange ? () => onChange(item.status) : undefined}
            disabled={disabled}
            selected={isSelected}
            id="participated_tooltip"/>
        );
      })
      }

    </>
  );
}
